"use client";

import { SiteNav, SiteFooter, BLOG_STYLES, BLOG_ARTICLE_STYLES } from "./chrome";
import { STYLES as BASE_STYLES } from "./LandingV2";

const REGISTER_URL = "https://dashboard.lvlup-app.com/auth/register";

export function BlogStyles() {
  return (
    <style
      dangerouslySetInnerHTML={{
        __html: BASE_STYLES + BLOG_STYLES + BLOG_ARTICLE_STYLES,
      }}
    />
  );
}

export function BlogShell({ children }: { children: React.ReactNode }) {
  return (
    <div className="lvlup-landing">
      <BlogStyles />
      <SiteNav current="blog" />
      <main>{children}</main>
      <SiteFooter />
    </div>
  );
}

export function BlogHero() {
  return (
    <section className="bp-hero">
      <div className="bp-hero-grid" />
      <div className="bp-hero-glow" />
      <div className="lp-container bp-hero-inner">
        <span className="lp-eyebrow">
          <svg width="11" height="11" viewBox="0 0 12 12" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <path d="M2 2h8v8H2zM2 4h8M4 2v8" />
          </svg>
          Expert Insights
        </span>
        <h1>Master the art of <span className="lp-accent">successful coaching</span></h1>
        <p className="bp-lead">
          Discover proven strategies, expert insights, and success stories from top coaches worldwide.
          Learn how to build, scale, and optimize your coaching business for maximum impact.
        </p>
        <div className="bp-hero-ctas">
          <a href="/pricing" className="lp-btn lp-btn-primary lp-btn-lg">Start Your Journey</a>
          <a href="#newsletter" className="lp-btn lp-btn-ghost lp-btn-lg">Get Updates</a>
        </div>

      </div>
    </section>
  );
}

/**
 * Compact CTA for the article-page sidebar slot — fills its container
 * instead of forcing the 1240px banner width.
 */
export function ArticleCTA() {
  return (
    <div className="lvlup-landing" style={{ display: "contents" }}>
      <BlogStyles />
      <div
        style={{
          background: "var(--accent)",
          color: "var(--accent-ink)",
          borderRadius: 24,
          padding: 28,
          width: "100%",
          maxWidth: "100%",
          position: "relative",
          overflow: "hidden",
          boxSizing: "border-box",
          marginTop: 24,
        }}
      >
        <div
          aria-hidden
          style={{
            position: "absolute",
            top: -60,
            right: -60,
            width: 220,
            height: 220,
            background: "repeating-linear-gradient(45deg, transparent 0 10px, rgba(0,0,0,0.06) 10px 11px)",
            borderRadius: "50%",
            pointerEvents: "none",
          }}
        />
        <h3
          style={{
            position: "relative",
            fontFamily: "var(--display)",
            fontSize: 22,
            fontWeight: 700,
            letterSpacing: "-0.4px",
            lineHeight: 1.05,
            margin: "0 0 8px",
            color: "var(--accent-ink)",
            textWrap: "balance",
          }}
        >
          Ready to start coaching?
        </h3>
        <p
          style={{
            position: "relative",
            margin: "0 0 16px",
            fontSize: 14,
            lineHeight: 1.5,
            color: "rgba(0,0,0,0.7)",
          }}
        >
          Don't wait for the perfect moment. Start building your coaching business today with LVLUP.
        </p>
        <a
          href={REGISTER_URL}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            position: "relative",
            display: "inline-flex",
            alignItems: "center",
            gap: 8,
            background: "var(--accent-ink)",
            color: "var(--accent)",
            padding: "12px 18px",
            borderRadius: 10,
            fontFamily: "var(--ui)",
            fontSize: 14,
            fontWeight: 600,
            textDecoration: "none",
          }}
        >
          Start your 14-day free trial
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round">
            <path d="M3 7h8m-3-3l3 3-3 3" />
          </svg>
        </a>
      </div>
    </div>
  );
}

